import React from 'react'
import ResultsSection, { NotAvailable } from './ResultsSection'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '~/lib/ui/accordion'
import useTranslation from '../shared/TranslationProvider'

const VideoSection = ({ career, ...props }) => {
  const video = career.video
  const transcript = video?.transcript
  const { t } = useTranslation('video')
  if (!video) return <NotAvailable section="video" career={career} {...props} />

  return (
    <ResultsSection section="video" career={career} {...props}>
      <video muted="muted" controls={true} className="rounded-[6px]">
        <source src={video.url} autoPlay={false} />
      </video>
      {transcript && (
        <Accordion type="single" collapsible>
          <AccordionItem value="item-1">
            <AccordionTrigger>{t('video_transcript')}</AccordionTrigger>
            <AccordionContent>
              <div>{transcript}</div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      )}
    </ResultsSection>
  )
}

export default VideoSection
